import { render } from "./TraineeHome.vue?vue&type=template&id=bd1210f8&scoped=true"
import script from "./TraineeHome.vue?vue&type=script&lang=js"
export * from "./TraineeHome.vue?vue&type=script&lang=js"

import "./TraineeHome.vue?vue&type=style&index=0&id=bd1210f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1210f8"]])

export default __exports__